import React from "react";
import PropTypes from "prop-types";
import Button from "@mui/material/Button";
import { styled } from "@mui/system";
import { Icon } from "../home/OverviewIcon";
function StyledButtonWIcon(props) {
  const { children, size, selected, sx, iconName, ...otherProps } = props;
  return (
    <Button
      variant="contained"
      disableElevation
      disableRipple
      size={size ?? "large"}
      startIcon={
        <Icon type={iconName} sx={{ mr: -0.6, my: -0.6, p: 0, border: 0 }} />
      }
      sx={{
        m: 0,
        p: 0,
        mx: { xs: 0.1, sm: 0.5 },
        my: 0,
        px: { xs: 1, sm: 1 },
        py: 0.0,
        // border: 0,
        fontSize: {
          xs: "subtitle1.fontSize",
          sm: "subtitle1.fontSize",
        },
        fontWeight: "bold",
        color: selected ? "secondary5.common" : "secondary.main",
        // border: selected ? 0.2 : 0,
        // borderColor: "secondary.main",
        borderRadius: props.pill ? 50 : "10px 10px 10px 10px",
        boxShadow: 0,
        ":hover": {
          // bgcolor: "common.secondary7",
          boxShadow: 0,
          bgcolor: "common.secondary2",
          // bgcolor: "common.secondary2",

          // color: "secondary.main",
          // fontWeight: "light",
        },
        ":disabled": {
          boxShadow: 0,
          // bgcolor: "common.commbg",
          // border: 0.2,
          // borderColor: "secondary.main",
          color: "common.secondary5",
        },
        "&.active": {
          // bgcolor: selected ? "common.compbg" : "secondary.main",
          color: selected ? "secondary5.common" : "textAlt",
          // border: 0.2,
        },
        "&:clicked": {
          // bgcolor: selected ? "common.compbg" : "secondary.main",
          color: selected ? "secondary.main" : "textAlt",
          // border: 0.2,
        },
        ...sx,
      }}
      {...otherProps}
    >
      {children}
    </Button>
  );
}

// StyledButton.propTypes = {
//   onClick: PropTypes.func.isRequired,
// };

// export default StyledButton;

// const StyledButton = styled(
//   "Button"
//   // , { shouldForwardProp: (props) => props}
// )(({ theme }) => ({
//   variant: "contained",
//   color: "textAlt",
//   disableElevation: true,
// }));
export default StyledButtonWIcon;
